// packages imports
import { Box, Divider, Grid, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useEffect } from 'react'

// components imports
import { CustomController } from '../../../common/CustomController'
import BillingCyclesList from './BillingCyclesList'
import BankAccountsList from './BankAccountsList'

// others
import { AccountType, useFetchRetainerAccountLazyQuery } from '../../../../../generated'
import { GRAPHQL_QUERY_POLICY } from '../../../../constants'
import { CustomDatePickerController } from '../../../common/CustomDatePickerRController'
import InfoTooltip from '../../../common/InfoTooltip'

const HourlyBillingForm = () => {
  const { setValue, watch } = useFormContext()

  const [fetchRetainerAccount] = useFetchRetainerAccountLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,
    onError() {},
    onCompleted(data) {
      if (data?.fetchRetainerAccount) {
        setValue('billing.retainerAccountId', data.fetchRetainerAccount.id)
      }
    }
  })

  useEffect(() => {
    const retainerAccountId = watch('billing.retainerAccountId')

    if (!retainerAccountId) {
      fetchRetainerAccount()
    }
  }, [fetchRetainerAccount, watch])

  return (
    <Grid container item rowSpacing={2.5}>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1" textTransform={'uppercase'} fontSize={16} fontWeight={700}>
          Retainer
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <CustomController
          fieldType="number"
          controllerName="billing.retainerAmount"
          controllerLabel="Retainer Amount"
          dollarAdornment
          sx={{ my: 0 }}
        />
      </Grid>
      <Grid item xs={12}>
        <BankAccountsList name="billing.retainerAccountId" title="Bank Account"/>
        <InfoTooltip info="Make sure to choose the bank account correctly. For Hourly Billing, bank account for retainer amount should be trust account but you can choose any bank account." />
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <BillingCyclesList name="billing.billingCycle" title="Billing Cycle" />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <CustomController
          fieldType="number"
          controllerName="billing.minimumFundsThreshold"
          controllerLabel="Minimum Funds Threshold"
          dollarAdornment
          sx={{ my: 0 }}
        />
      </Grid>
      <Box mt={2.5}>
        <CustomDatePickerController
          controllerName="billing.pauseBillingUntil"
          controllerLabel="Billing Paused Until"
          sx={{ my: 0 }}
        />
        <InfoTooltip info="Billing paused means that the monthly retainer amount and special payments (if any) will not be charged until the date (if selected) in above field. However, all the expense entries, cost entries or other legal fee entries will still be part of the monthly bill." />
      </Box>
    </Grid>
  )
}

export default HourlyBillingForm
